// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1JtlG","rootSmall":"AddTileButton_rootSmall__1yE2n"};